import { getAuth, signOut } from "firebase/auth";

export class FireAuth {
  static signOut = async () => await signOut(getAuth());
}
